import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { addStoreBalance, getStoreWalletbalance } from '../../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const Storewalletbalance = () => {
  const token = useSelector((state) => state.user.token);

  const [storeBalance, setStorebalance] = useState([])

  const [payModal, setPayModal] = useState(null)

  // New state to handle the history popup
  const [historyModal, setHistoryModal] = useState(null)

  const [ammount, setAmmount] = useState("")

  const handleGetStoreWallet = async () => {
    try {
      const response = await getStoreWalletbalance(token)
      console.log("getStoreWalletbalance", response);
      if (response.status === 200) {
        setStorebalance(response.data)
      }

    } catch (error) {
      console.log(error);

    }
  }

  const handleAddStoreBalance = async (data) => {
    try {
      const response = await addStoreBalance(data, token)
      console.log("submit balance data", response);
      if (response.status === 200) {
        toast.success("Balance added successfully")
        setPayModal(null)
        setAmmount("") // Clear amount after success
        handleGetStoreWallet()
      }

    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    handleGetStoreWallet()
  }, [])

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div>
          <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
            <thead>
              <tr style={{ textAlign: "center" }}>
                <th>Id</th>
                <th style={{ textAlign: "center" }}>Name</th>
                <th style={{ textAlign: "center" }}>Balance</th>
                <th style={{ textAlign: "center" }}>View History</th>
                <th style={{ textAlign: "center" }}>Add balance</th>
              </tr>
            </thead>

            <tbody>
              {storeBalance?.map((user, index) => (
                <tr key={user?.id}>
                  <td>{index + 1}</td>
                  <td>
                    <span className="font-16">{user.storeName}</span>
                  </td>
                  <td>{user?.balance}</td>
                  
                  {/* Updated View Button */}
                  <td style={{ textAlign: "center" }}>
                    <button 
                      onClick={() => setHistoryModal(user)}
                      className="btn btn-sm btn-info"
                      style={{ color: "white" }}
                    >
                      View
                    </button>
                  </td>

                  <td>
                    <button onClick={() => setPayModal(user.storeId)}
                      style={{ padding: "8px", borderRadius: "5px", backgroundColor: "#0e71f1ff", color: "white", border: "none" }}>
                      Add
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Add Funds Modal */}
          {
            payModal &&
            <div style={{ width: "300px", height: "200px", borderRadius: "10px", zIndex: 999, position: "absolute", backgroundColor: "white", border: "1px solid grey", padding: "15px", right: "50px", top: "20vh", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
              <p onClick={() => setPayModal(null)}
                style={{ position: "absolute", top: "5px", right: "10px", cursor: "pointer", fontWeight: "bold" }}>X</p>
              <label>Enter Amount</label>
              <input value={ammount}
                type="number"
                onChange={(e) => setAmmount(e.target.value)}
                placeholder='Enter Amount'
                style={{ padding: "5px", outline: "none", border: "0.5px solid grey", width: "100%", marginTop: "5px" }} />
              <button
                onClick={() => handleAddStoreBalance({ storeDetailsId: payModal, amount: ammount })}
                style={{ padding: "8px", borderRadius: "5px", backgroundColor: "#0e71f1ff", marginTop: "20px", color: "white", width: "100%", border: "none" }}>
                Submit
              </button>
            </div>
          }

          {/* History Modal - Displays the history array from the selected store */}
          {
            historyModal &&
            <div style={{
              width: "60%",
              minWidth: "300px",
              maxHeight: "80vh",
              overflowY: "auto",
              borderRadius: "10px",
              zIndex: 1000,
              position: "fixed",
              backgroundColor: "white",
              border: "1px solid grey",
              padding: "20px",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: "0 0 15px rgba(0,0,0,0.2)"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <h5 style={{ margin: 0 }}>History: {historyModal.storeName}</h5>
                <button onClick={() => setHistoryModal(null)} className="btn btn-sm btn-danger">Close</button>
              </div>

              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Description</th>
                      <th>Type</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historyModal.history && historyModal.history.length > 0 ? (
                      historyModal.history.map((item, idx) => (
                        <tr key={idx}>
                          <td>{new Date(item.createdAt).toLocaleString()}</td>
                          <td>{item.description}</td>
                          <td>
                            <span className={`badge ${item.transactionType === 'CREDIT' ? 'badge-success' : 'badge-danger'}`}>
                              {item.transactionType}
                            </span>
                          </td>
                          <td style={{ fontWeight: "bold", color: item.transactionType === 'CREDIT' ? 'green' : 'red' }}>
                            {item.transactionType === 'CREDIT' ? '+' : '-'} {item.amount}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">No history found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          }

        </div>

      </div>

    </div>
  )
}

export default Storewalletbalance
